import api from './api'
import type { View } from '../types'

export const viewApi = {
  getViews: (siteId: string) => api.get<View[]>(`/sites/${siteId}/views`).then((r) => r.data),
  createView: (siteId: string, data: Partial<View>) => api.post<View>(`/sites/${siteId}/views`, data).then((r) => r.data),
  updateView: (siteId: string, id: string, data: Partial<View>) => api.patch<View>(`/sites/${siteId}/views/${id}`, data).then((r) => r.data),
  deleteView: (siteId: string, id: string) => api.delete(`/sites/${siteId}/views/${id}`),
  setDefaultView: (siteId: string, viewId: string) => api.put(`/sites/${siteId}/default-view`, { view_id: viewId }),
}
